require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-strengthens-leadership-to-support-future-growth.json") })
        }
      }, "path---articles-financial-center-strengthens-leadership-to-support-future-growth");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-strengthens-leadership-to-support-future-growth!./.cache/json/articles-financial-center-strengthens-leadership-to-support-future-growth.json
// module id = 1678
// module chunks = 231608221292675